import * as React from 'react';
import styled from '@emotion/styled';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import { Box } from '@mui/material';

const StarRoot = styled(Box)`
  display: inline-block;
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`;

const SegmentLayer = styled(Box)`
  position: absolute;
  top: 0.4px;
  left: ${({ sectionThickness }) => -sectionThickness}px;
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
`;

const Segment = styled(Box, { shouldForwardProp: (prop) => !['filled', 'size', 'sectionThickness', 'rotation'].includes(prop) })`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-left: ${({ size, sectionThickness, filled }) => `${(size / 4) + sectionThickness}px solid ${filled ? 'orange' : 'transparent'}`};
  border-top: ${({ sectionThickness }) => `${sectionThickness}px solid transparent`};
  border-bottom: ${({ sectionThickness }) => `${sectionThickness}px solid transparent`};
  transform-origin: 0 50%;
  clip-path: polygon(43% 0, 100% 50%, 43% 100%, 0 50%);
  transform: ${({ rotation }) => `rotate(${rotation}deg)`};
`;

const StarOutlineIcon = styled(StarBorderOutlinedIcon)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: grey;
  font-size: ${({ size }) => size}px;
`;

const SegmentedStar = ({ value, size=20 }) => {
  const segments = 5;
  const filledSegments = Math.min(Math.max(value, 0), 5);
  const degreePerSegment = 360 / segments;
  const sectionThickness = size/8;
  return (
    <StarRoot size={size}>
      {/* Background segments */}
      <SegmentLayer sectionThickness={sectionThickness}>
        {[...Array(segments)].map((_, index) => (
          <Segment
            key={index}
            filled={index < filledSegments}
            size={size}
            sectionThickness={sectionThickness}
            rotation={index * degreePerSegment}
          />
        ))}
      </SegmentLayer>

      {/* Star outline on top */}
      <StarOutlineIcon size={size} />
    </StarRoot>
  );
};

export default SegmentedStar;
